<div>
  <input
    type="file"
    #fileChooser
    placeholder="Choose file"
    style="display: none"
  />
  <p-button
    [styleClass]="'w-full'"
    [icon]="'fa fa-plus fa-fw'"
    type="button"
    [label]="file ? file.name : ('button:Choose_file' | i18next)"
    (click)="fileChooser.click()"
  ></p-button>
</div>
